export const DEFAULT_PAGE_SIZE = 10;
export const MAX_VISIBLE_BUTTONS_DESKTOP = 11;
export const MAX_VISIBLE_BUTTONS_MOBILE = 4;